import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "vxe-context-menu--link"
};
const _hoisted_2 = {
  class: "vxe-context-menu--link-prefix"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
  class: "vxe-context-menu--link-suffix"
};
import MgSubMenu from './mg-sub-menu.vue';
import { computed } from 'vue';
export default {
  __name: 'mg-menu-item',
  props: {
    data: {
      type: Object,
      default: () => ({
        title: '',
        icon: '',
        shortcut: '',
        disabled: false,
        checked: false,
        children: []
      })
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  emits: ['mouseenter', 'mouseleave', 'subMouseenter', 'subMouseleave', 'click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      title,
      icon,
      shortcut,
      disabled,
      checked,
      children
    } = props.data;
    const hasChildren = computed(() => {
      return !!children && Array.isArray(children) && children.length > 0;
    });
    const handleMouseenter = e => {
      emit('mouseenter', {
        $event: e,
        item: props.data
      });
    };
    const handleMouseleave = e => {
      emit('mouseleave', {
        $event: e,
        item: props.data
      });
    };
    const handleClick = e => {
      if (!hasChildren.value) {
        emit('click', {
          $event: e,
          item: props.data
        });
      }
    };
    const handleSubItemClick = ({
      item,
      $event
    }) => {
      emit('click', {
        $event,
        item
      });
    };
    const handleSubItemMouseenter = ({
      item,
      $event
    }) => {
      emit('subMouseenter', {
        item,
        $event
      });
    };
    const handleSubItemMouseleave = ({
      item,
      $event
    }) => {
      emit('subMouseleave', {
        item,
        $event
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          'link--active': __props.active,
          'link--disabled': _unref(disabled)
        }),
        onMouseenter: handleMouseenter,
        onMouseleave: handleMouseleave,
        onClick: _withModifiers(handleClick, ["stop"])
      }, [_createElementVNode("a", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, () => [_createElementVNode("i", {
        class: _normalizeClass(_unref(icon))
      }, null, 2)])]), _createElementVNode("div", {
        class: "vxe-context-menu--link-content",
        title: _unref(title)
      }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(_unref(title)), 1)])], 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("i", {
        class: _normalizeClass({
          'vxe-table-icon-arrow-right': hasChildren.value,
          'vxe-icon-check': !hasChildren.value && _unref(checked)
        })
      }, null, 2), !!_unref(shortcut) ? _renderSlot(_ctx.$slots, "shortcut", {
        key: 0
      }, () => [_createElementVNode("span", null, _toDisplayString(_unref(shortcut)), 1)]) : _createCommentVNode("", true)])]), hasChildren.value ? (_openBlock(), _createBlock(MgSubMenu, {
        key: 0,
        items: _unref(children),
        show: __props.active,
        onItemClick: handleSubItemClick,
        onItemMouseenter: handleSubItemMouseenter,
        onItemMouseleave: handleSubItemMouseleave
      }, null, 8, ["items", "show"])) : _createCommentVNode("", true)], 34);
    };
  }
};